import React, { useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap"

/**
 * Ek modül silme onayı.
 *
 * <p>Satılmış modüller backend tarafından 409 ile korunur; bu modal silmeyi
 * <b>denemeden önce</b> uyarır ama son sözü backend söyler. Firmalara tanımlı
 * bir modül silinemez çünkü hangi ürünün satıldığı kaydı muhasebe ve iade
 * için gereklidir — bu durumda modülün pasife alınması gerekir.
 */
const AddonDeleteModal = ({ isOpen, toggle, module, onConfirm }) => {
  const [deleting, setDeleting] = useState(false)

  const handleConfirm = async () => {
    try {
      setDeleting(true)
      await onConfirm(module)
    } finally {
      setDeleting(false)
    }
  }

  const sold = (module?.purchaseCount || 0) > 0

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="text-danger">
        <i className="bx bx-trash me-2" />
        Ek Modülü Sil
      </ModalHeader>
      <ModalBody>
        <div className="text-center mb-3">
          <i className="bx bx-error-circle text-danger" style={{ fontSize: 48 }} />
          <p className="mt-2 mb-0">
            Bu ek modülü silmek istediğinize emin misiniz? Bu işlem geri alınamaz.
          </p>
        </div>

        <div className="bg-light rounded-3 p-3">
          <div className="d-flex justify-content-between mb-1">
            <span className="text-muted" style={{ fontSize: ".82rem" }}>Modül</span>
            <span className="fw-semibold">{module?.name}</span>
          </div>
          <div className="d-flex justify-content-between mb-1">
            <span className="text-muted" style={{ fontSize: ".82rem" }}>Tip</span>
            <span>{module?.lifecycleLabel || "-"}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text-muted" style={{ fontSize: ".82rem" }}>Tanımlı firma</span>
            <span className={sold ? "fw-semibold text-danger" : ""}>{module?.purchaseCount ?? 0}</span>
          </div>
        </div>

        {sold && (
          <div className="mt-3 p-3 rounded-3" style={{ background: "#FFF4E5", border: "1px solid #FFD8A8" }}>
            <i className="bx bx-info-circle me-1" style={{ color: "#B86E00" }} />
            <span style={{ fontSize: ".82rem" }}>
              Bu modül firmalara tanımlı olduğu için silinemez. Satışa kapatmak için
              modülü <strong>pasife almanız</strong> gerekir.
            </span>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={deleting}>
          İptal
        </Button>
        <Button color="danger" onClick={handleConfirm} disabled={deleting || sold}>
          {deleting ? <Spinner size="sm" /> : "Evet, Sil"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AddonDeleteModal
